export const HOME = "/";
export const CLAIM = "/claim";
export const LIVE = "/live";
export const COMING_SOON = "/coming-soon";
export const RESULT = "/result";
export const DEXX_VICTIM = "/dexx-victim";
export const STAKING = "/staking";
export const ASK_AI = "/ask-ai";
